import dom, { Fragment } from "../../../../../dist/jsx-render/dom";
import { app } from "../../../../Frame/App";
import { ColumnHarvey } from "../../../Table/ColumnHarvey";
import { ITableColumn } from "../../../Table/ITableColumn";
import { TableColumnTypes } from "../../../Table/TableColumnTypes";
import { MeasureDocumentsDropdown } from "../../../../Components/MeasureDocumentsDropdown";
import { ArrowCreator } from "./DomFunctions/ArrowCreator";
import { CustomAmpel } from "./DomFunctions/CustomAmpel";
import { MeasureEditFactory } from "../../../../Pages/Measure/MeasureEditFactory";
import { PopupCloseType } from "../../../PagePopup";
import { CategoryFunctions } from "./DomFunctions/CategoryFunctions";
import { Documents } from "./DomFunctions/Documents";
import { MsoTable } from "../../../Table/MsoTable";
import { ListFunctions } from "./DomFunctions/ListFunctions";
import { DynPopup, DynPopupProps } from "../../../../Components/DynPopup";
import { AvatarProps, Avatar } from "../../../../Components/UIElements/Avatar";
import { MatrixObject } from "../../../../Areas/Admin/Measures/TemplateEdit/Matrix/MatrixObject";
import { MatrixControl } from "../../../Dynamic/Matrix/MatrixControl";
import { FullscreenDisplay } from "../../../Dynamic/Matrix/Modules/FullscreenDisplay";
import { SiemensEnergy } from "./DomFunctions/SiemensEnergy";
import { CurrentDate } from "./DomFunctions/CurrentDate";
import { ImageFunctions } from "./DomFunctions/ImageFunctions";

export class ProcessedMarkup {
    public markup: string;
    public deferredElements: DeferredElement[];
}

export class MatrixModel {
    public jsonDefinition: string;
    public fieldsValues: { [field: string]: string };
    public iterationDate: Date;
    public additionalMultiRows: number;
}

export class DeferredElement {
    public completeElement: HTMLElement;
    public placeholderId: string;
    public markup: string;
    public type: string;
    public name: string;

    public isValid: boolean = true;

    public insert = (element: HTMLElement, jsonData: any) => {
        let placeholderDiv = element.querySelector(`#${this.placeholderId}`) as HTMLElement;

        if (placeholderDiv) {
            switch (this.type) {
                case "massnahmeNew":
                    // name is templateId
                    let templateId = Number(this.name);
                    if (!isNaN(templateId)) {
                        $.ajax({
                            url: app.resolveUrl(`~/api/widget/checkLayoutItemTemplateRights/${this.type}/${this.name}`),
                            method: "GET",
                            success: (response) => {
                                if (response == true) {
                                    this.insertIntoDom(placeholderDiv, element, jsonData);
                                }
                            },
                            error: (err) => {
                                console.log(err);
                            },
                            complete: () => {
                                // Remove placeholderDiv
                                app.destroyDomElements(placeholderDiv);
                            }
                        });
                    }

                    break;

                case "workflow":
                    const urlParams = new URLSearchParams(window.location.search);
                    const measureIdString = urlParams.get("parentId");
                    let measureId: number = 0;

                    if (measureIdString) {
                        measureId = Number(measureIdString);
                    }

                    if (measureId != 0) {
                        $.ajax({
                            url: app.resolveUrl(`~/api/widget/checkLayoutItemMeasureRights/${this.name}/${measureId}`),
                            method: "GET",
                            success: (response) => {
                                if (response == true) {
                                    this.insertIntoDom(placeholderDiv, element, jsonData);
                                }
                            },
                            error: (err) => {
                                console.log(err);
                            },
                            complete: () => {
                                // Remove placeholderDiv
                                app.destroyDomElements(placeholderDiv);
                            }
                        });
                    }
                    break;

                case "yesNoField":
                    // Format: yesNoField:[Lf#xxx]
                    if (this.name == Resources.Common.yes) {
                        this.insertIntoDom(placeholderDiv, element, jsonData);
                    } else {
                        // Remove placeholderDiv
                        app.destroyDomElements(placeholderDiv);
                    }
                    break;

                // add other cases here

                default:
                    return;
            }
        }
    }

    private insertIntoDom = (placeholderDiv: HTMLElement, element: HTMLElement, jsonData: any) => {

        // Check the markup of this deferred element for nested deferred elements to allow nested <hide>s.
        let nestedProcessedMarkup = DesignParser.processDeferredElements(this.markup);

        // Placeholders (fields, localized strings, fixed placeholders) are already replaced here.
        let templateElement = document.createElement("div");
        templateElement.innerHTML = nestedProcessedMarkup.markup;

        // Right now just one child element in <hide ..> </hide> is supported.
        var parsedElement = templateElement.firstElementChild;

        var parent = placeholderDiv.parentNode;
        if (parent) {
            parent.insertBefore(parsedElement, placeholderDiv);
        }

        DesignParser.executeDomFunctions(parsedElement as HTMLElement, element, jsonData);
        DesignParser.setLinksFromJson(parsedElement as HTMLElement, jsonData);

        for (let item of nestedProcessedMarkup.deferredElements) {
            item.insert(element, jsonData);
        }
    }

    public setParameters = (parameterString: string, deferredText: string) => {
        // Split parameters
        let typeAndName = parameterString.split(":");

        if (typeAndName.length == 2) {
            this.type = typeAndName[0];
            this.name = typeAndName[1];
        } else {
            this.isValid = false;
        }

        if (this.isValid) {
            this.placeholderId = app.createRadomizedLetters(20);
            this.markup = deferredText;
        } else {
            console.log(`Processing hidden elements in widget: The parameter string '${parameterString}' is invalid. Expected: 'type:name'.`);
        }
    }
}

export class DesignParser {
    private static openingTag: string = "<hide";
    private static closingTag: string = "</hide>";

    public static parseDesign(container: HTMLElement, markup: string) {
        // Parse HTML from HTML-Encoded string. If this is usable by normal users, html should be sanitized.
        //container.innerHTML =  markup;
        container.innerHTML = container.innerHTML + markup;
    }

    public static appendStyles(widgetId: string, styles: string) {
        const existingStyleTag = document.head.querySelector(`#${widgetId}`) as HTMLStyleElement;
        if (existingStyleTag) {
            document.head.removeChild(existingStyleTag);
        }

        document.head.appendChild(
            <style id={widgetId}>
                {styles}
            </style>
        );
    }



    public static processDeferredElements = (markup: string, level: number = 0): ProcessedMarkup => {
        let deferredElements: DeferredElement[] = [];

        let markupCopy = markup;

        /** Counts the levels of nesting. if the level > 0, found opnening tags are ignored and the level is reduced by one, if a closing tag is found.
         * DeferredElements are only created, if an opening and closing tag on level 0 are found. */
        let levels = 0;

        let openingTag = "<hide";
        let closingTag = "</hide>";

        let indexOpenTag = markupCopy.indexOf(openingTag);
        let counter = 1;
        while (indexOpenTag > -1) {

            if (counter == 100) break;
            counter++;

            let level = 1;
            let indexNextOpen = markupCopy.indexOf(openingTag, indexOpenTag + 1);
            let indexNextClose = markupCopy.indexOf(closingTag);

            if (indexNextClose == -1) {
                console.log("Found <hide()> without corresponding closing tag.");
                break;
            } else if (indexNextOpen == markupCopy.length) {
                // No more openingTags found 
            } else {
                while (level < 100 && indexNextOpen != -1 && indexNextOpen < indexNextClose) {
                    level += 1;
                    indexNextOpen = markupCopy.indexOf(openingTag, indexNextOpen + 1);
                }

                for (let i = level; i > 1; i--) {
                    indexNextClose = markupCopy.indexOf(closingTag, indexNextClose + 1);
                }
            }

            // find closing bracket of openingTag '>'
            var substringWithOpenTag = markupCopy.substring(indexOpenTag);
            let indexEndOfOpenTag = substringWithOpenTag.indexOf(">");
            let matchOpen = substringWithOpenTag.substring(0, indexEndOfOpenTag + 1);

            let deferredText = markupCopy.substring(indexOpenTag + matchOpen.length, indexNextClose);
            
            if (deferredText.length > 0) {
                let deferredElement = new DeferredElement();

                // Parse parameters from opening tag - format: templateId, blockId, id of parent element
                let parameterString = matchOpen.replace("<hide(", "").replace(")>", "");
                deferredElement.setParameters(parameterString, deferredText);

                if (deferredElement.isValid) {
                    deferredElements.push(deferredElement);
                }

                let textToReplace = matchOpen + deferredText + DesignParser.closingTag;

                // Replace deferred element with placeholder div
                markupCopy = markupCopy.replace(textToReplace, `<div class="d-none" id="${deferredElement.placeholderId}"></div>`);

                indexOpenTag = markupCopy.indexOf(openingTag);
            }
        }

        let processedMarkup = new ProcessedMarkup();
        processedMarkup.markup = markupCopy;
        processedMarkup.deferredElements = deferredElements;

        return processedMarkup;
    }

    // erstmal noch drin lassen...
    //public static processDeferredElements = (markup: string): ProcessedMarkup => {
    //    let deferredElements: DeferredElement[] = [];

    //    let markupCopy = markup;

    //    // Regex: (<workflow\().*(\)>)
    //    let regexOpen = new RegExp("(<hide\\().*(\\)>)", "m");
    //    let regexClose = new RegExp("(</hide>)", "m");

    //    let otherMatches = regexOpen.exec(markupCopy);
    //    if (otherMatches.length > 0) {
    //        console.log(otherMatches);
    //    }

    //    let matches = markupCopy.match(regexOpen);

    //    while (matches && matches.length > 0) {
    //        let matchOpen = matches[0];
    //        let matchClosingTag: string = null;

    //        let matchesClosingTag = markupCopy.match(regexClose);
    //        if (matchesClosingTag.length > 0) {
    //            matchClosingTag = matchesClosingTag[0];
    //        } else {
    //            // Closing tag not found, end loop
    //            break;
    //        }

    //        // Get text between both matches
    //        let innerText = markupCopy.slice(markupCopy.indexOf(matchOpen) + matchOpen.length, markupCopy.indexOf(matchClosingTag));

    //        // Parse parameters from opening tag - format: templateId, blockId, id of parent element
    //        let parameterString = matchOpen.replace("<hide(", "").replace(")>", "");

    //        let deferredElement = new DeferredElement();
    //        let isValid: boolean = true;

    //        // Split parameters
    //        let typeAndName = parameterString.split(":");

    //        if (typeAndName.length == 2) {
    //            deferredElement.type = typeAndName[0];
    //            deferredElement.name = typeAndName[1];
    //        } else {
    //            isValid = false;
    //        }

    //        if (isValid) {
    //            deferredElement.placeholderId = app.createRadomizedLetters(20);
    //            deferredElement.markup = innerText;
    //            deferredElements.push(deferredElement);
    //        } else {
    //            console.log(`Processing hidden elements in widget: The parameter string '${parameterString}' is invalid. Expected: 'type:name'.`);
    //        }

    //        // Remove opening tag, closing tag and everything between from markupCopy
    //        // and replace with a <div class="d-none"> and a specific id. If the element is evaluated to be visible, the div will be replaced with it.
    //        markupCopy = markupCopy.substring(0, markupCopy.indexOf(matchOpen))
    //            + `<div class="d-none" id="${deferredElement.placeholderId}"></div>`
    //            + markupCopy.substring(markupCopy.indexOf(matchClosingTag) + matchClosingTag.length);

    //        matches = markupCopy.match(regexOpen);
    //    }

    //    let processedMarkup = new ProcessedMarkup();
    //    processedMarkup.markup = markupCopy;
    //    processedMarkup.deferredElements = deferredElements;

    //    return processedMarkup;
    //}

    public static setLinksFromJson(element: HTMLElement, jsonObject: any) {
        if (jsonObject) {
            for (let key in jsonObject) {
                if (key.startsWith("link")) {
                    var linkElements = DesignParser.queryElements(element, `[data-link="${key}"]`)
                    if (linkElements && linkElements.length > 0) {
                        linkElements.forEach((e) => {
                            (e as HTMLElement).addEventListener("mouseover", (ev: MouseEvent) => {
                                // set a class on a parent element to emulate hover behavior 
                                // with arrows which consist of multiple seperate elements.

                                // Determine the parent element to set the class on by the attribute data-link-parent
                                (ev.target as HTMLElement)?.closest("[data-link-parent]")?.classList.add("link-hover");
                            });

                            (e as HTMLElement).addEventListener("mouseout", (ev: MouseEvent) => {
                                (ev.target as HTMLElement)?.closest("[data-link-parent]")?.classList.remove("link-hover");
                            });

                            (e as HTMLElement).addEventListener("click", () => {
                                window.location.href = app.resolveUrl(jsonObject[key]);
                            });
                            (e as HTMLElement).classList.add("pointer");
                        });
                    }
                }
                else if (key.startsWith("image")) {
                    var imageElements = DesignParser.queryElements(element, `img[data-image="${key}"], i[data-image="${key}]"`);
                    if (imageElements && imageElements.length > 0) {
                        imageElements.forEach((e) => {
                            (e as HTMLImageElement).src = app.resolveUrl(jsonObject[key]);
                        });
                    }
                }
            }
        }
    }

    /**
     * Execute all special functions that the user could trigger in the markup using specific data attributes (e.g. data-make-arrows etc.).
     * @param element The HTML Element that was parsed from the given markup of the widget.
     * @param masterElement Optional, the complete parsed HTML Element of the widget, when we are creating a deferred element.
     */
    public static executeDomFunctions(element: HTMLElement, masterElement: HTMLElement = null, jsonData: any = null) {

        // Function: Create Arrows from divs with data-make-arrow attribute.
        DesignParser.makeArrows(element);

        // Custom Ampel functions
        let customAmpel = new CustomAmpel();
        customAmpel.create(element);
        customAmpel.createAggregateAmpeln(element, masterElement);

        // Function: Harvey Ball using ajax to retrieve its value.
        DesignParser.createHarveyBalls(element);
        DesignParser.CreateAvatars(element);
        DesignParser.createProgressBars(element);

        // Function: Create a dropdown menu from an element to show all documents in the measure.
        DesignParser.createDocumentsDropdown(element);

        DesignParser.newMeasureLinks(element);

        CategoryFunctions.createMultiCategoryItems(element);
        ListFunctions.createUserList(element);
        ListFunctions.createListMeasureLinks(element);
        ImageFunctions.createMultiLanguageImages(element);
        Documents.createDocumentLists(element);

        DesignParser.createMsoTables(element, jsonData);
        DesignParser.createPopups(element, jsonData, masterElement);

        DesignParser.createMatrix(element);

        if (app.customApp == "SiemensEnergy") {
            SiemensEnergy.createCwDropdown(element);
            SiemensEnergy.createCwEditButton(element);
            SiemensEnergy.createCwAddButton(element);
        }

        CurrentDate.createCurrentDate(element);

        // enable bootstrap tooltips
        $(function () {
            $('[data-toggle="tooltip"]').tooltip();
        });

        // enable bootstrap popovers
        $(function () {
            $('[data-toggle="popover"]').popover();
        });

        DesignParser.createGeneralUserPositionStorage(element);
    }

    /**
    * Gets all elements that have the attribute data-expander, and add the event handler to show/hide details.
    * 
    * The element should be inside a div element with className "m-content" which can contains "m-details" element or "m-children" element
    * The element with the attribute data-expander will also need data-view-id to get listviewId to be called in the callback event to show children elements (m-children).
    * @param element : The HTML Element that was parsed from the given markup of the widget.
    * @param callback : post-call to show the measure childrens by giving the viewId
    */
    public static createExpanderEvent(element: HTMLElement, callback: (itemEelemt: HTMLElement, measureId: number, viewId: number) => void = null) {
        var expanderElements = this.queryElements(element, "[data-expander]");
        expanderElements.forEach((e) => {
            let expandElement = e as HTMLElement;

            let viewId = expandElement.getAttribute("data-view-id");
            let contentElement = expandElement.closest(".m-content") as HTMLElement;
            let caretElement = expandElement.querySelector(".fa-caret-right") as HTMLElement;

            // set event handler
            expandElement.addEventListener("click", (ev: MouseEvent) => {
                ev.stopPropagation();
                ev.stopPropagation();

                let detailDivElement = contentElement?.querySelector(".m-details") as HTMLElement;
                $(element).toggleClass("open");


                if (element.classList.contains("open")) {
                    // change expander icon display: right (>) ==> down (v)
                    caretElement.style.transform = "rotate(90deg)";

                    let measureItemId = element.getAttribute("data-id");
                    if (measureItemId) {
                        // remove all measure children
                        element.querySelector(".m-children")?.remove();

                        // create measure children element
                        let childElement = <div className="m-children mt-2 mb-3" style={{ "margin-left": "5em" }}></div>
                        element.appendChild(childElement);

                        // if measure has invisible field on initialize  => show it on expand
                        // use attr "data-field-invisible"
                        this.queryElements(contentElement, "[data-field-invisible]").forEach(e => { (e as HTMLDivElement).classList.remove("d-none"); })

                        if (callback) {
                            callback(childElement, parseInt(measureItemId), parseInt(viewId));
                        }
                    }

                } else {
                    // remove all measure children
                    element.querySelectorAll(".m-children")?.forEach(e => e.remove());
                    caretElement.style.removeProperty("transform");
                    contentElement?.querySelectorAll("[data-field-invisible]")?.forEach(e => { (e as HTMLDivElement).classList.add("d-none"); })
                }

                $(detailDivElement)?.toggle("slow");

                this.addExpandedInfoStorageHandler(ev);
            });
        });

    }

    /**
     * Gets all elements that have the attribute data-make-arrow, and creates two additional HTML elements before and after.
     * It will create a horizontal arrow like structure like this: >___> from a given div.
     * The parent Element needs to have display: flex, flex-direction: row for this to work properly.
     * 
     * Data attributes from the parent element (except data-stroke, data-stroke-width, data-fill) will be applied to the created svg elements, too.
     * 
     * The element with the attribute data-make-arrow will also need data-stroke, data-stroke-width, data-fill.
     * @param element
     */
    private static makeArrows(element: HTMLElement) {
        var arrowElements = this.queryElements(element, "[data-make-arrow]");

        arrowElements.forEach((e) => {
            let arrowElement = e as HTMLElement;
            ArrowCreator.create(arrowElement);
        });
    }

    /**
     * Custom Harvey ball using ajax to retrieve its value. Usage: <div data-harvey-ball-url="~/my/url" />
     * @param element
     */
    public static createHarveyBalls(element: HTMLElement) {
        var harveyBallElements = this.queryElements(element, "[data-harvey-ball-url]");
        harveyBallElements.forEach(e => {
            let hbElement = e as HTMLElement;
            let url = hbElement.getAttribute("data-harvey-ball-url");

            if (url) {
                $.ajax({
                    url: app.resolveUrl(url),
                    method: "GET",
                    success: (response) => {
                        if (!isNaN(Number(response))) {
                            let fakeTableDef: ITableColumn = { type: TableColumnTypes.Harvey, number: 1 };
                            let column = new ColumnHarvey(null, fakeTableDef, "");
                            let svgElement = column.generateHarveyBall(response);

                            hbElement.appendChild(svgElement);
                        } else {
                            console.log(`Request to ${url} didn't return a number. Response: ${response}`);
                        }
                    },
                    error: (err) => {
                        console.log(err);
                    }
                });
            }
        });
    }

    public static CreateAvatars(element: HTMLElement) {
        let avatarElements = this.queryElements(element, "[data-avatar]");
        avatarElements.forEach(e => {
            let avElement = e as HTMLElement;

            let userId = avElement.getAttribute("data-user-id");
            if (userId) {

                $.ajax({
                    url: app.resolveUrl("~/api/users/getImageInfo/"),
                    method: "POST",
                    data: JSON.stringify([userId]),
                    contentType: "application/json",
                    success: (data) => {
                        if (data["length"] && data.length > 0) {
                            var user = data[0];

                            avElement.appendChild(<Avatar id={userId} name={user.name} hasImage={user.hasImage} type="user" />)
                        }
                    },
                    error: (err) => {
                        console.log(err);
                    }
                });
            }
        });
    }

    //**Store user position info (expanded elements and scroll position)*/
    public static createUserPositionStorage(element: HTMLElement) {
        if (element) {
            let userPositionContainers = this.queryElements(element, "[saveState='true']");

            if (userPositionContainers && userPositionContainers.length != 0) {
                this.processUserPositionStorage(userPositionContainers);
            }
        }
    }

    //**Store measure element expanded state*/
    public static addExpandedInfoStorageHandler(event) {
        let clickItem = event.target as HTMLElement;
        if (clickItem) {
            let checkSaveState = clickItem.closest("[saveState = 'true']");
            if (checkSaveState) {
                let item = clickItem.closest("[position-id]");
                if (item) {
                    let info = item.closest(".measure-item") as HTMLElement;
                    if (info) {
                        this.setItemExpanded(item.getAttribute("position-id"), info.classList.contains("open"));
                    }
                }
            }
        }
    }

    //**Store general user position info (expanded elements and scroll position)*/
    public static createGeneralUserPositionStorage(element: HTMLElement) {
        if (element) {
            let userPositionContainers = this.queryElements(element, "[saveState='true']");

            if (userPositionContainers && userPositionContainers.length != 0) {
                let index = 0;
                for (let positionContainer of userPositionContainers) {
                    let positionElementsHeader = this.queryElements(positionContainer, ".vs-header");
                    if (positionElementsHeader && positionElementsHeader.length != 0) {
                        for (let positionElement of positionElementsHeader) {
                            let positionAttribute = `index-${index}`;
                            index++;
                            positionElement.setAttribute("position-id", positionAttribute);
                            positionElement.onclick = (event) => {
                                let item = (event.target as HTMLElement).closest("[position-id]");
                                let info = item.closest("details") as HTMLElement;
                                if (info) {
                                    this.setItemExpanded(item.getAttribute("position-id"), !info.hasAttribute("open"));
                                }
                            }

                            let details = positionElement.closest("details") as HTMLElement;
                            if (details && this.isItemExpanded(positionAttribute)) {
                                details.setAttribute("open", '');
                            }
                        }
                    }
                }
            }
        }
    }

    //**Setup scroll to position functionality*/
    public static setScrollPosition() {
        let container = document.querySelector(".content-container") as HTMLElement;
        if (container) {
            let checkSaveState = container.closest("[saveState = 'true']");
            if (checkSaveState) {
                container.onscroll = (event) => {
                    let item = event.target as HTMLElement;
                    this.setItemValue("scroll-position", item.scrollTop);
                }

                setTimeout(() => {
                    let scrollTo = this.getItemValue("scroll-position");
                    if (scrollTo != 0) {
                        $(".content-container").ready(function () {
                            $(".content-container").scrollTop(scrollTo);
                        });
                    }
                }, 500);
            }
        }
    }

    //**Store and process user expanded elements info*/
    private static processUserPositionStorage (containers: HTMLElement[]) {
        for (let positionContainer of containers) {
            let positionElementsExpanders = this.queryElements(positionContainer, "[data-expander]");
            if (positionElementsExpanders && positionElementsExpanders.length != 0) {
                for (let positionElement of positionElementsExpanders) {
                    let measureItem = positionElement.closest(".measure-item") as HTMLElement;
                    if (measureItem && measureItem.hasAttribute("data-id")) {
                        let positionAttribute = `data-id-${measureItem.getAttribute("data-id")}`;
                        positionElement.setAttribute("position-id", positionAttribute);

                        if (this.isItemExpanded(positionAttribute)) {
                            positionElement.click();
                        }
                    }
                }
            }
        }
    }

    //**Store expanded elements info*/
    private static setItemExpanded = (key: string, value: boolean) => {
        if (value) {
            sessionStorage.setItem(key, "expanded");
        }
        else {
            sessionStorage.removeItem(key);
        }
    }

    //**Check is element is expanded*/
    private static isItemExpanded = (key: string): boolean => {
        let item = sessionStorage.getItem(key);
        return item && item == "expanded";
    }

    //**Store numeric info like scroll position*/
    private static setItemValue = (key: string, value: number) => {
        sessionStorage.setItem(key, value.toString());
    }

    //**Get numeric info like scroll position*/
    private static getItemValue = (key: string): number => {
        var item = sessionStorage.getItem(key);
        if (item && !isNaN(+item)) {
            return +item;
        }

        return 0;
    }

    /**
     * Creates progress bars. Usage: <div data-progress-bar data-progress-url="url">
     * 
     * Uses the children <div data-progress-number /> to display the progress as number.
     * And <div class="progress-left" /> to set the progress as width for the filled progress bar.
     * 
     * @param element
     */
    public static createProgressBars(element: HTMLElement) {
        let progElements = this.queryElements(element, "[data-progress-bar]");
        progElements.forEach(e => {
            let progElement = e as HTMLElement;

            let url = progElement.getAttribute("data-progress-url");

            if (url) {

                $.ajax({
                    url: app.resolveUrl(url),
                    method: "GET",
                    success: (response) => {

                        if (!isNaN(Number(response))) {
                            let responseInt = Math.round(response);

                            let numberElements = progElement.querySelectorAll("[data-progress-number]");
                            numberElements.forEach(n => {
                                let numberElement = n as HTMLElement;
                                numberElement.innerHTML = responseInt.toString();
                            });

                            let progressBarElements = progElement.querySelectorAll(".progress-left");
                            progressBarElements.forEach(p => {
                                let pBarElement = p as HTMLElement;
                                pBarElement.style.width = responseInt.toString() + "%";
                            });

                        } else {
                            console.log(`Request to ${url} didn't return a number. Response: ${response}`);
                        }
                    },
                    error: (err) => {
                        console.log(err);
                    }
                });
            } else {
                let value = progElement.getAttribute("data-progress-value");
                let progressBarElements = progElement.querySelectorAll(".progress-left");
                progressBarElements.forEach(p => {
                    let pBarElement = p as HTMLElement;
                    if (value != "")
                        pBarElement.style.width = value + "%";
                });
                let numberElements = progElement.querySelectorAll("[data-progress-number]");
                numberElements.forEach(n => {
                    let numberElement = n as HTMLElement;
                    if (value != "")
                        numberElement.innerHTML = value.toString() + "%";
                });
            }
        });
    }

    public static createDocumentsDropdown(element: HTMLElement) {
        var documentElements = this.queryElements(element, "[data-documents-dropdown]");

        const urlParams = new URLSearchParams(window.location.search);
        const measureIdString = urlParams.get("parentId");
        if (measureIdString) {
            let measureId = parseInt(measureIdString);
            documentElements.forEach((e, index) => {
                let docElement = e as HTMLElement;

                docElement.addEventListener("click", (event: MouseEvent) => {
                    event.stopPropagation();
                    event.cancelBubble = true;

                    docElement.appendChild(<MeasureDocumentsDropdown measureId={measureId} parentElement={docElement} alignRight={true} />);
                });
            });
        }
    }

    public static newMeasureLinks(element: HTMLElement) {
        let newMeasureLinks = this.queryElements(element, "[data-new-measure]");
        newMeasureLinks.forEach((e) => {
            let element = e as HTMLElement;
            element.classList.add("pointer");
            element.addEventListener("click", (event: MouseEvent) => {
                event.stopPropagation();
                event.preventDefault();
                let closestButton = (event.target as HTMLElement).closest("a[data-new-measure]") as HTMLElement;
                if (closestButton) {
                    let templateIdString = closestButton.getAttribute("data-template-id");
                    let templateId = Number(templateIdString);

                    if (templateId != null && templateId != undefined && !isNaN(templateId) && templateId != 0) {
                        const urlParams = new URLSearchParams(window.location.search);
                        const measureIdString = urlParams.get("parentId");

                        // In case we use nested widget, we define an attribute "data-parent-id"
                        let measureParentId = closestButton.getAttribute("data-parent-id");

                        let measureId = 0;
                        if (measureParentId) {
                            measureId = Number(measureParentId);
                        } else if (measureIdString) {
                            measureId = Number(measureIdString);
                        }

                        if (measureId != 0) {
                            if (!isNaN(measureId)) {
                                MeasureEditFactory.showMeasure({
                                    measureId: 0,
                                    templateId: templateId,
                                    parentId: measureId,
                                    parentGuid: "",
                                    fullScreen: true,
                                    onClose: ((reason: PopupCloseType, id: number) => {
                                        document.location = document.location;
                                    })
                                });
                            }
                        }
                    }
                } else {
                    console.log("Closest button element not found for this element:");
                    console.log(element)
                }
            });
        });
    }

    public static createMsoTables = (element: HTMLElement, jsonData: any) => {
        // get parent id from url
        let parentId = app.getParameterByName("parentId");
        //if (app.isNullOrUndefined(parentId)) {
        //    parentId = "-1";
        //}

        // get all table definitions
        var tableDivs = DesignParser.queryElements(element, ".mso-table-autogenerate");
        tableDivs.forEach((value: Element) => {
            // set parent id and create MsoTable
            if (parentId) {
                value.setAttribute("data-parent-id", parentId);
            }
            let table = new MsoTable(value as HTMLElement);
            table.props.getTextForNewButton = (templateId: number): string => {
                if (jsonData && jsonData["newMeasureButton_" + templateId] && jsonData["newMeasureButton_" + templateId][app.language]) {
                    return jsonData["newMeasureButton_" + templateId][app.language];
                }
                return Resources.Common.newMeasure;
            }
        });
    }

    /**
     * This can be extended to allow the setting of showHeader, showFooter, which buttons are shown, etc.
     * The current implementation uses default values appropriate for the vetter-strategie application.
     * @param element
     * @param jsonData
     * @param masterElement If the clickTarget is not found on the passed element, it will be searched on the masterElement. 
     * This applies to hidden Elements. Still, there might be cases when the popup and the click target are both on hidden elements, that the click target cannot be found.
     * Watch out where you put the click target.
     */
    public static createPopups = (element: HTMLElement, jsonData: any, masterElement: HTMLElement = null) => {
        let popupElements = DesignParser.queryElements(element, "[data-is-popup]");
        popupElements.forEach((e) => {
            let popupElement = e as HTMLElement;
            let clickTargetId = popupElement.getAttribute("data-click-target");

            let clickTarget = element.querySelector(`#${clickTargetId}`);
            if (!clickTarget && masterElement) {
                clickTarget = masterElement.querySelector(`#${clickTargetId}`);
            }

            if (clickTarget) {
                popupElement.parentElement.removeChild(popupElement);

                clickTarget.addEventListener("click", (ev: MouseEvent) => {
                    let popupProps: DynPopupProps = {
                        showFooter: false,
                        showCloseButton: true,
                        size: "fit",
                        children: popupElement
                    };

                    let popup = new DynPopup(popupProps);

                    document.body.appendChild(popup.render());
                });

            } else {
                console.log("ClickTarget for Popup not found");
            }
        });
    }

    public static createMatrix (element: HTMLElement){
        var matrixElements = this.queryElements(element, "[data-use-matrix]");
        matrixElements.forEach((matrix: HTMLElement) => {
            var fieldId = parseInt(matrix.getAttribute("data-matrix"));
            var measureId = parseInt(matrix.getAttribute("data-measure"));

            if (!isNaN(fieldId) && !isNaN(measureId)) {
                $.ajax({
                    method: "GET",
                    url: app.resolveUrl("~/api/measure/getMatrixData/" + fieldId + "/" + measureId),
                    contentType: "application/json",
                    async: false,
                    success: (data: MatrixModel) => {
                        if (data) {
                            this.analyzeMatrix(data, matrix, measureId);
                        }
                    },
                    error: (err) => {
                        console.log(err);
                    }
                });
            }
        })
    }

    private static analyzeMatrix = (data: MatrixModel, containerElement: HTMLElement, measureId: number) => {
        try {
            let container: HTMLElement = <div className="readonly-matrix"></div>;
            let json: any = null;
            if (data.jsonDefinition)
                json = JSON.parse(data.jsonDefinition);
            let matrixObject = MatrixObject.fromJson(json);
            matrixObject.containerElement = container;
            matrixObject.useInWidget = true;
            matrixObject.widgetModel.widgetFields = data.fieldsValues;
            matrixObject.widgetModel.widgetIterationDate = data.iterationDate;
            if (data.additionalMultiRows) {
                matrixObject.additionalMultiRows = [];
                let count = 1;
                while (count <= data.additionalMultiRows) {
                    matrixObject.additionalMultiRows.push(count);
                    count++;
                }
            }

            let control = new MatrixControl(null, matrixObject, measureId, new FullscreenDisplay());
            containerElement.appendChild(matrixObject.containerElement);
        }
        catch {
            console.log("Error in creating Matrix");
        }

    }
    /**
     * Uses element.querySelectorAll and also includes the element if it matches the selector. 
     * Unforutnately, querySelectorAll only returns children of element.
     * @param element
     * @param selector
     */
    private static queryElements(element: HTMLElement, selector: string): HTMLElement[] {
        let nodes = element.querySelectorAll(selector);
        let nodesArray: HTMLElement[] = [];
        nodes.forEach((e) => nodesArray.push(e as HTMLElement));

        if (element.matches(selector)) nodesArray.push(element);

        return nodesArray;
    }
}